import React from 'react'

// Text nur für Screenreader — dieselbe Technik wie WordPress' screen-reader-text.
const VisuallyHidden = ({ children }) => <span className="jm-sr-only">{children}</span>

export default VisuallyHidden
